var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"view-container"},[(_vm.imgUrl)?_c('img',{ref:"galleyImg",attrs:{"src":_vm.imgUrl,"alt":_vm.alt},on:{"click":function($event){$event.stopPropagation();return _vm.handleView($event)}}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0752de4c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--5!./src/component/viewImg/viewImg.vue
// module id = 12
// module chunks = 0